import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import axios from "axios";
import { io } from "socket.io-client";
import Swal from "sweetalert2";
import toast, { Toaster } from "react-hot-toast";

// Serve Icon Component
const ServeIcon = ({ isServing }) => {
  const fillColor = isServing ? "#72B900" : "#E0E0E0";

  return (
    <svg
      width="41"
      height="41"
      viewBox="0 0 41 41"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="20.5" cy="20.5" r="20.5" fill={fillColor} />
      <path
        d="M14.0117 23.1974C15.5013 23.1974 16.7089 21.9898 16.7089 20.5002C16.7089 19.0106 15.5013 17.803 14.0117 17.803C12.522 17.803 11.3145 19.0106 11.3145 20.5002C11.3145 21.9898 12.522 23.1974 14.0117 23.1974Z"
        fill="white"
      />
      <path
        d="M23.0478 11.9189C23.0478 13.4094 21.9234 14.6161 20.5337 14.6161C19.144 14.6161 18.0195 13.4094 18.0195 11.9189C18.0195 10.4283 19.144 9.22168 20.5337 9.22168C21.9234 9.22168 23.0478 10.4283 23.0478 11.9189Z"
        fill="white"
      />
      <path
        d="M10.7874 11.3622C10.2495 12.7519 8.9233 13.5327 7.82499 13.1068C6.72669 12.6809 6.27466 11.209 6.81261 9.81934C7.35055 8.42964 8.67674 7.64887 9.77505 8.07475C10.8734 8.50062 11.3254 9.9725 10.7874 11.3622Z"
        fill="white"
      />
      <path
        d="M4.0293 23.1974C4.80918 23.1974 5.4414 21.9898 5.4414 20.5002C5.4414 19.0106 4.80918 17.803 4.0293 17.803C3.24941 17.803 2.61719 19.0106 2.61719 20.5002C2.61719 21.9898 3.24941 23.1974 4.0293 23.1974Z"
        fill="white"
      />
      <path
        d="M27.0566 23.1974C28.5462 23.1974 29.7538 21.9898 29.7538 20.5002C29.7538 19.0106 28.5462 17.803 27.0566 17.803C25.567 17.803 24.3594 19.0106 24.3594 20.5002C24.3594 21.9898 25.567 23.1974 27.0566 23.1974Z"
        fill="white"
      />
      <path
        d="M30.2804 11.3622C30.8183 12.7519 32.1445 13.5327 33.2428 13.1068C34.3411 12.6809 34.7932 11.209 34.2552 9.81934C33.7173 8.42964 32.3911 7.64887 31.2928 8.07475C30.1945 8.50062 29.7424 9.9725 30.2804 11.3622Z"
        fill="white"
      />
      <path
        d="M37.0381 23.1974C37.818 23.1974 38.4502 21.9898 38.4502 20.5002C38.4502 19.0106 37.818 17.803 37.0381 17.803C36.2582 17.803 35.626 19.0106 35.626 20.5002C35.626 21.9898 36.2582 23.1974 37.0381 23.1974Z"
        fill="white"
      />
      <path
        d="M20.5341 5.44116C22.0237 5.44116 23.2313 4.80894 23.2313 4.02905C23.2313 3.24917 22.0237 2.61694 20.5341 2.61694C19.0445 2.61694 17.8369 3.24917 17.8369 4.02905C17.8369 4.80894 19.0445 5.44116 20.5341 5.44116Z"
        fill="white"
      />
      <path
        d="M23.0478 29.0773C23.0478 27.5868 21.9234 26.3801 20.5337 26.3801C19.144 26.3801 18.0195 27.5868 18.0195 29.0773C18.0195 30.5679 19.144 31.7745 20.5337 31.7745C21.9234 31.7745 23.0478 30.5679 23.0478 29.0773Z"
        fill="white"
      />
      <path
        d="M10.7874 29.6377C10.2495 28.248 8.9233 27.4672 7.82499 27.8931C6.72669 28.319 6.27466 29.7909 6.81261 31.1806C7.35055 32.5703 8.67674 33.351 9.77505 32.9251C10.8734 32.4993 11.3254 31.0274 10.7874 29.6377Z"
        fill="white"
      />
      <path
        d="M30.2804 29.6377C30.8183 28.248 32.1445 27.4672 33.2428 27.8931C34.3411 28.319 34.7932 29.7909 34.2552 31.1806C33.7173 32.5703 32.3911 33.351 31.2928 32.9251C30.1945 32.4993 29.7424 31.0274 30.2804 29.6377Z"
        fill="white"
      />
      <path
        d="M20.5341 38.3831C22.0237 38.3831 23.2313 37.7508 23.2313 36.9709C23.2313 36.1911 22.0237 35.5588 20.5341 35.5588C19.0445 35.5588 17.8369 36.1911 17.8369 36.9709C17.8369 37.7508 19.0445 38.3831 20.5341 38.3831Z"
        fill="white"
      />
    </svg>
  );
};

const LiveMatch = () => {
  const { matchId, court } = useParams();
  const navigate = useNavigate();
  const [match, setMatch] = useState(null);
  const [loading, setLoading] = useState(true);
  const [socket, setSocket] = useState(null);

  // Socket.IO connection
  useEffect(() => {
    const newSocket = io(
      "https://api-third-shot-score-684526581556.asia-south1.run.app",
      {
        transports: ["websocket", "polling"],
        timeout: 20000,
        reconnection: true,
        reconnectionAttempts: 5,
        reconnectionDelay: 1000,
        reconnectionDelayMax: 5000,
        maxReconnectionAttempts: 10,
        forceNew: true,
      }
    );

    // Connection event handlers
    newSocket.on("connect", () => {
      console.log("✅ WebSocket connected successfully");
      // Join specific match room or court room
      if (matchId) {
        newSocket.emit("joinMatch", matchId);
      } else if (court) {
        newSocket.emit("joinCourt", court);
      }
    });

    newSocket.on("disconnect", (reason) => {
      console.log("❌ WebSocket disconnected:", reason);
    });

    newSocket.on("connect_error", (error) => {
      console.error("❌ WebSocket connection error:", error);
    });

    newSocket.on("reconnect", (attemptNumber) => {
      console.log("🔄 WebSocket reconnected after", attemptNumber, "attempts");
      // Re-join specific match room or court room after reconnection
      if (matchId) {
        newSocket.emit("joinMatch", matchId);
      } else if (court) {
        newSocket.emit("joinCourt", court);
      }
    });

    newSocket.on("reconnect_error", (error) => {
      console.error("❌ WebSocket reconnection error:", error);
    });

    newSocket.on("reconnect_failed", () => {
      console.error("❌ WebSocket reconnection failed");
    });

    setSocket(newSocket);

    // Set up periodic heartbeat to keep connection alive
    const heartbeatInterval = setInterval(() => {
      if (newSocket.connected) {
        newSocket.emit("ping");
      }
    }, 30000); // Send ping every 30 seconds

    return () => {
      clearInterval(heartbeatInterval);
      if (matchId) {
        newSocket.emit("leaveMatch", matchId);
      } else if (court) {
        newSocket.emit("leaveCourt", court);
      }
      newSocket.close();
    };
  }, [matchId, court]);

  // Fetch match data on component mount
  useEffect(() => {
    fetchMatch();
  }, [matchId, court]);

  // Handle Socket.IO messages
  useEffect(() => {
    if (!socket) return;

    socket.on("scoreUpdate", (data) => {
      if (matchId && data.matchId === parseInt(matchId)) {
        setMatch(data.match);
      } else if (court && data.match && data.match.court === court) {
        setMatch(data.match);
      }
    });

    socket.on("setEnd", (data) => {
      if (matchId && data.matchId === parseInt(matchId)) {
        setMatch(data.match);
      } else if (court && data.match && data.match.court === court) {
        setMatch(data.match);
      }
    });

    socket.on("serveUpdate", (data) => {
      if (matchId && data.matchId === parseInt(matchId)) {
        setMatch(data.match);
      } else if (court && data.match && data.match.court === court) {
        setMatch(data.match);
      }
    });

    socket.on("matchEnd", (data) => {
      if (matchId && data.matchId === parseInt(matchId)) {
        setMatch(data.match);
        Swal.fire({
          title: "Match Completed!",
          text: "Redirecting to home page...",
          icon: "success",
          timer: 2000,
          showConfirmButton: false,
        }).then(() => {
          navigate("/");
        });
      } else if (court && data.match && data.match.court === court) {
        // For court-based URLs, immediately clear the match to show "No active match"
        setMatch(null);
      }
    });

    socket.on("matchCreated", (data) => {
      console.log("🎾 LiveMatch: Received matchCreated event:", data);
      if (court && data.match && data.match.court === court) {
        console.log("🎾 LiveMatch: Setting match for court:", court);
        setMatch(data.match);
      } else if (
        matchId &&
        data.match &&
        data.match.matchId === parseInt(matchId)
      ) {
        console.log("🎾 LiveMatch: Setting match for matchId:", matchId);
        setMatch(data.match);
      }
    });

    socket.on("courtCleared", (data) => {
      if (court && data.court === court) {
        setMatch(null);
      }
    });

    socket.on("undoScore", (data) => {
      if (matchId && data.matchId === parseInt(matchId)) {
        setMatch(data.match);
      } else if (court && data.match && data.match.court === court) {
        setMatch(data.match);
      }
    });

    return () => {
      socket.off("scoreUpdate");
      socket.off("setEnd");
      socket.off("serveUpdate");
      socket.off("matchEnd");
      socket.off("matchCreated");
      socket.off("courtCleared");
      socket.off("undoScore");
    };
  }, [socket, matchId, court]);

  const fetchMatch = async () => {
    try {
      let response;
      if (matchId) {
        response = await axios.get(
          `https://api-third-shot-score-684526581556.asia-south1.run.app/pickleball/match/${matchId}`
        );
      } else if (court) {
        response = await axios.get(
          `https://api-third-shot-score-684526581556.asia-south1.run.app/pickleball/court/${court}`
        );
      }

      if (response && response.data.success) {
        setMatch(response.data.data);
      }
    } catch (error) {
      console.error("Error fetching match:", error);
      if (matchId) {
        Swal.fire({
          title: "Match not found",
          text: "Redirecting to home page...",
          icon: "error",
          timer: 2000,
          showConfirmButton: false,
        }).then(() => {
          navigate("/");
        });
      } else if (court) {
        // For court-based URLs, don't redirect if no active match
        setMatch(null);
      }
    } finally {
      setLoading(false);
    }
  };

  const handleScoreUpdate = async (team) => {
    try {
      if (!match) return;

      console.log(
        `Updating score for team ${team}, current set: ${match.currentSet}`
      );
      const response = await axios.post(
        `https://api-third-shot-score-684526581556.asia-south1.run.app/pickleball/score/${match.matchId}`,
        {
          team: team,
        }
      );
      if (response.data.success) {
        setMatch(response.data.data);
        console.log("Score updated successfully:", response.data.data);
        // toast.success("Score updated successfully!");
      }
    } catch (error) {
      console.error("Error updating score:", error);
      toast.error(error.response?.data?.message || "Failed to update score");
    }
  };

  const handleUndo = async (team) => {
    try {
      if (!match) return;

      console.log(
        `Undoing score for team ${team}, current set: ${match.currentSet}`
      );
      const response = await axios.post(
        `https://api-third-shot-score-684526581556.asia-south1.run.app/pickleball/undo/${match.matchId}`,
        {
          team: team,
        }
      );
      if (response.data.success) {
        setMatch(response.data.data);
        console.log("Score undone successfully:", response.data.data);
        // toast.success("Score undone successfully!");
      }
    } catch (error) {
      console.error("Error undoing score:", error);
      toast.error(error.response?.data?.message || "Failed to undo score");
    }
  };

  const handleToggleServe = async (team) => {
    try {
      if (!match) return;

      console.log(`Toggling serve for team ${team}`);
      const response = await axios.post(
        `https://api-third-shot-score-684526581556.asia-south1.run.app/pickleball/toggle-serve/${match.matchId}`,
        {
          team: team,
        }
      );
      if (response.data.success) {
        setMatch(response.data.data);
        console.log("Serve toggled successfully:", response.data.data);
        // toast.success("Serve toggled successfully!");
      }
    } catch (error) {
      console.error("Error toggling serve:", error);
      toast.error(error.response?.data?.message || "Failed to toggle serve");
    }
  };

  const handleEndSet = async () => {
    if (!match) return;

    const result = await Swal.fire({
      title: "Are you sure you want to end this set?",
      text: "This action cannot be undone.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#FC2020",
      cancelButtonColor: "#6c757d",
      confirmButtonText: "Yes, end it!",
      cancelButtonText: "No, cancel!",
    });

    if (result.isConfirmed) {
      try {
        const response = await axios.post(
          `https://api-third-shot-score-684526581556.asia-south1.run.app/pickleball/end-set/${match.matchId}`
        );
        if (response.data.success) {
          setMatch(response.data.data);
          // toast.success("Set ended successfully!");

          // Check if match is completed after ending set
          if (response.data.data.status === "completed") {
            Swal.fire({
              title: "Match Completed!",
              text: "Redirecting to home page...",
              icon: "success",
              timer: 2000,
              showConfirmButton: false,
            }).then(() => {
              navigate("/");
            });
          }
        }
      } catch (error) {
        console.error("Error ending set:", error);
        toast.error(error.response?.data?.message || "Failed to end set");
      }
    }
  };

  const handleEndMatch = async () => {
    if (!match) return;

    const result = await Swal.fire({
      title: "Are you sure you want to end this match?",
      text: "This action cannot be undone.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#FC2020",
      cancelButtonColor: "#6c757d",
      confirmButtonText: "Yes, end it!",
      cancelButtonText: "No, cancel!",
    });

    if (result.isConfirmed) {
      try {
        // Check if current set has scores and end it first
        const currentSet = match.sets.find(
          (s) => s.setNumber === match.currentSet
        );
        if (
          currentSet &&
          (currentSet.teamAScore > 0 || currentSet.teamBScore > 0)
        ) {
          console.log("Ending current set before ending match...");
          const setResponse = await axios.post(
            `https://api-third-shot-score-684526581556.asia-south1.run.app/pickleball/end-set/${match.matchId}`
          );
          if (setResponse.data.success) {
            setMatch(setResponse.data.data);
            // Check if match is completed after ending set
            if (setResponse.data.data.status === "completed") {
              Swal.fire({
                title: "Match Completed!",
                text: "Redirecting to home page...",
                icon: "success",
                timer: 2000,
                showConfirmButton: false,
              }).then(() => {
                navigate("/");
              });
              return;
            }
          }
        }

        // Now end the match
        const response = await axios.post(
          `https://api-third-shot-score-684526581556.asia-south1.run.app/pickleball/end-match/${match.matchId}`
        );
        if (response.data.success) {
          setMatch(response.data.data);
          Swal.fire({
            title: "Match Completed!",
            text: "Redirecting to home page...",
            icon: "success",
            timer: 2000,
            showConfirmButton: false,
          }).then(() => {
            navigate("/");
          });
        }
      } catch (error) {
        console.error("Error ending match:", error);
        toast.error(error.response?.data?.message || "Failed to end match");
      }
    }
  };

  const getSetScore = (sets, setNumber, team) => {
    const set = sets.find((s) => s.setNumber === setNumber);
    if (!set) return "";

    if (team === "A") {
      return set.teamAScore.toString();
    } else {
      return set.teamBScore.toString();
    }
  };

  const getTotalSets = (sets, team, teamA, teamB) => {
    return sets.filter((set) => set.winner === (team === "A" ? teamA : teamB))
      .length;
  };

  const isSetWinner = (sets, setNumber, teamName) => {
    const set = sets.find((s) => s.setNumber === setNumber);
    return set && set.winner === teamName;
  };

  const shouldShowSet = (match, setNumber) => {
    // If match is not active, show all sets
    if (match.status !== "active") {
      return true;
    }

    // For active matches, only show current set and past sets
    // Don't show future sets (display as 0)
    console.log(setNumber <= match.currentSet);
    return setNumber <= match.currentSet;
  };

  const getVisibleSets = (match) => {
    // Get all sets that should be displayed
    const visibleSets = [];
    const maxSetNumber = Math.max(...match.sets.map((s) => s.setNumber));

    for (let i = 1; i <= maxSetNumber; i++) {
      if (shouldShowSet(match, i)) {
        visibleSets.push(i);
      }
    }

    return visibleSets;
  };

  const getGridCols = (visibleSets) => {
    // Generate dynamic grid columns based on number of visible sets
    const setCols = visibleSets.length * 50; // 50px per set
    return `grid-cols-[1fr_50px_${visibleSets.map(() => "50px").join("_")}]`;
  };

  if (loading) {
    return (
      <div
        className="min-h-screen"
        style={{
          background:
            "linear-gradient(99.32deg, rgb(1 30 72) -0.41%, rgb(17 64 132) 93.61%)",
        }}
      >
        <div className="flex items-center justify-center h-screen">
          <div className="text-white text-xl">Loading...</div>
        </div>
      </div>
    );
  }

  if (!match) {
    return (
      <div
        className="min-h-screen"
        style={{
          background:
            "linear-gradient(99.32deg, rgb(1 30 72) -0.41%, rgb(17 64 132) 93.61%)",
        }}
      >
        <div className="flex items-center justify-center h-screen">
          <div className="text-white text-xl">
            {court
              ? `No active match on ${court.replace("court-", "Court ")}`
              : "Match not found"}
          </div>
        </div>
      </div>
    );
  }

  const teamASets = getTotalSets(match.sets, "A", match.teamA, match.teamB);
  const teamBSets = getTotalSets(match.sets, "B", match.teamA, match.teamB);
  const visibleSets = getVisibleSets(match);

  return (
    <div
      className="min-h-screen"
      style={{
        background:
          "linear-gradient(99.32deg, rgb(1 30 72) -0.41%, rgb(17 64 132) 93.61%)",
      }}
    >
      <Toaster
        position="top-right"
        toastOptions={{
          duration: 4000,
          style: {
            background: "#363636",
            color: "#fff",
          },
          success: {
            duration: 3000,
            iconTheme: {
              primary: "#028F64",
              secondary: "#fff",
            },
          },
          error: {
            duration: 4000,
            iconTheme: {
              primary: "#ef4444",
              secondary: "#fff",
            },
          },
        }}
      />
      {/* Header */}
      <div className="text-white p-6 pb-8">
        <h1 className="text-2xl font-bold text-center mb-2">
          Pickleball Live Score
        </h1>
        <p className="text-center text-sm opacity-90 mb-3">Powered by</p>
        <div className="flex justify-center">
          <img src={"https://storage.googleapis.com/pllayer-assests/Logo-white.png"} alt="PLLAYER" className="h-8" />
        </div>
      </div>

      {/* Main Content */}
      <div className="max-w-md mx-auto p-4">
        {/* Score Card - Same as Home.jsx */}
        <div className="bg-white rounded-lg shadow-md p-4 mb-3">
          {/* Score Table Layout */}
          <div className={`grid gap-2 mb-4 ${getGridCols(visibleSets)}`}>
            {/* Column Headers */}
            <div className="text-xs text-gray-500 font-medium text-left flex items-center gap-2">
              {" "}
              <div className="bg-black text-white text-xs px-3 py-1 w-fit rounded">
                Court : {match.court?.split("-")[1]}
              </div>
              {match.categoryMatchId
                ? match.categoryMatchId.toString().padStart(2, "0")
                : match.matchId.toString().padStart(2, "0")}
              {match?.matchTag !== "normal" && (
                <span
                  style={{
                    marginLeft: "10px",
                    background:
                      match.matchTag === "final"
                        ? "#ffc107"
                        : match.matchTag === "semi final"
                        ? "#36a2f3"
                        : match.matchTag === "quarter final"
                        ? "#6f42c1"
                        : "#e0e7ef",
                    color:
                      match.matchTag === "final"
                        ? "#001e48"
                        : match.matchTag === "semi final"
                        ? "#fff"
                        : match.matchTag === "quarter final"
                        ? "#fff"
                        : "#5b667a",
                    padding: "0.1rem 0.7rem",
                    borderRadius: "3px",
                    fontWeight: "bold",
                  }}
                  className="text-xs"
                >
                  {match.matchTag}
                </span>
              )}
            </div>
            <div className="text-xs text-gray-500 font-medium text-center w-[40px]">
              Sets
            </div>
            {visibleSets.map((setNumber) => (
              <div
                key={setNumber}
                className="text-xs text-gray-500 font-medium text-center w-[40px]"
              >
                {setNumber}
              </div>
            ))}

            {/* Player A Row */}
            <div className="text-sm flex items-center font-medium text-gray-800 truncate">
              {match.teamA}
            </div>
            <div
              className={`text-sm font-normal p-2 rounded text-center h-[40px] w-[40px] ${
                match.teamASetPoints > match.teamBSetPoints
                  ? "bg-[#001e48] text-white"
                  : "bg-[#fdf4ff] text-gray-800 border border-[#001e48]"
              }`}
            >
              {match.teamASetPoints}
            </div>
            {visibleSets.map((setNumber) => (
              <div
                key={setNumber}
                className={`text-sm font-medium p-2 rounded text-center h-[40px] w-[40px] ${
                  isSetWinner(match.sets, setNumber, match.teamA)
                    ? "bg-[#001e48] text-white"
                    : "bg-[#F2F2F2] text-gray-800"
                }`}
              >
                {getSetScore(match.sets, setNumber, "A")}
              </div>
            ))}

            {/* VS Row */}
            <div className="text-xs h-[12px] text-gray-400 font-medium truncate flex items-center">
              <div className="flex-1 h-px bg-gray-300 mr-2"></div>
              VS
              <div className="flex-1 h-px bg-gray-300 ml-2"></div>
            </div>
            <div className="h-[12px] flex items-center justify-center">
              <div className="w-full h-px bg-gray-300"></div>
            </div>
            {visibleSets.map((setNumber) => (
              <div
                key={setNumber}
                className="h-[12px] flex items-center justify-center"
              >
                <div className="w-full h-px bg-gray-300"></div>
              </div>
            ))}

            {/* Player B Row */}
            <div className="text-sm flex items-center font-normal text-gray-800 truncate">
              {match.teamB}
            </div>
            <div
              className={`text-sm font-medium p-2 rounded text-center h-[40px] w-[40px] ${
                match.teamBSetPoints > match.teamASetPoints
                  ? "bg-[#001e48] text-white"
                  : "bg-[#fdf4ff] text-gray-800 border border-[#001e48]"
              }`}
            >
              {match.teamBSetPoints}
            </div>
            {visibleSets.map((setNumber) => (
              <div
                key={setNumber}
                className={`text-sm font-medium p-2 rounded text-center h-[40px] w-[40px] ${
                  isSetWinner(match.sets, setNumber, match.teamB)
                    ? "bg-[#001e48] text-white"
                    : "bg-[#F2F2F2] text-gray-800"
                }`}
              >
                {getSetScore(match.sets, setNumber, "B")}
              </div>
            ))}
          </div>

          {/* Match Details Footer */}
          <div className="flex justify-between items-center">
            <span className="text-[#001e48] text-xs font-medium">
              {match.category}
            </span>
            <div className="flex items-center gap-1">
              <div className="w-2 h-2 bg-red-500 rounded-full"></div>
              <span className="text-red-500 text-xs font-medium">Live Now</span>
            </div>
          </div>
        </div>

        {/* Score Control Section */}
      </div>
      <div
        className="bg-gray-100 p-4 "
        style={{ height: "calc(100vh - 248px - 160px)" }}
      >
        {/* Current Set Indicator */}
        <div className="text-center mb-4">
          <div className="text-sm text-gray-600">
            Current Set: {match.currentSet}
            {match.currentSet === 3 && (
              <span className="ml-2 text-red-500 font-medium">(Final Set)</span>
            )}
          </div>
        </div>

        {/* Headers */}
        <div className="grid grid-cols-4 gap-4 mb-4 mt-5 text-center">
          <div className="text-sm font-medium text-gray-700">Players</div>
          <div className="text-sm font-medium text-gray-700">Serve</div>
          <div className="text-sm font-medium text-gray-700">Score</div>
          <div className="text-sm font-medium text-gray-700">Undo</div>
        </div>

        {/* Player Controls */}
        <div className="space-y-4">
          {/* Team A */}
          <div className="grid grid-cols-4 gap-4 items-center">
            <div className="text-sm font-medium text-gray-800">
              {match.teamA}
            </div>
            <div className="flex justify-center">
              <button
                onClick={() => handleToggleServe("A")}
                className="cursor-pointer"
              >
                <ServeIcon isServing={match.teamAServe} />
              </button>
            </div>
            <div className="flex justify-center">
              <button
                onClick={() => handleScoreUpdate("A")}
                className="w-12 h-12 bg-[#001e48] text-white rounded-lg font-bold text-lg hover:bg-[#7a1f9e] transition-colors"
              >
                +1
              </button>
            </div>
            <div className="flex justify-center">
              <button
                onClick={() => handleUndo("A")}
                className="w-12 h-12 bg-[#FFB72D] text-white rounded-lg font-bold text-lg hover:bg-[#e6a525] transition-colors"
              >
                U
              </button>
            </div>
          </div>

          {/* Team B */}
          <div className="grid grid-cols-4 gap-4 items-center">
            <div className="text-sm font-medium text-gray-800">
              {match.teamB}
            </div>
            <div className="flex justify-center">
              <button
                onClick={() => handleToggleServe("B")}
                className="cursor-pointer"
              >
                <ServeIcon isServing={match.teamBServe} />
              </button>
            </div>
            <div className="flex justify-center">
              <button
                onClick={() => handleScoreUpdate("B")}
                className="w-12 h-12 bg-[#001e48] text-white rounded-lg font-bold text-lg hover:bg-[#7a1f9e] transition-colors"
              >
                +1
              </button>
            </div>
            <div className="flex justify-center">
              <button
                onClick={() => handleUndo("B")}
                className="w-12 h-12 bg-[#FFB72D] text-white rounded-lg font-bold text-lg hover:bg-[#e6a525] transition-colors"
              >
                U
              </button>
            </div>
          </div>
        </div>
        {/* Match/Set Control Buttons */}
        <div className="grid grid-cols-2 gap-4 mt-16">
          <button
            onClick={handleEndMatch}
            className="bg-[#FC2020] text-white py-3 px-4 rounded-lg font-semibold text-sm hover:bg-[#e01c1c] transition-colors"
          >
            End Match
          </button>
          {match.currentSet !== 3 && (
            <button
              onClick={handleEndSet}
              className="bg-white text-[#FC2020] py-3 px-4 rounded-lg font-semibold text-sm border-2 border-[#FC2020] hover:bg-[#FC2020] hover:text-white transition-colors"
            >
              End Set
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default LiveMatch;
